import { createReducer, on } from '@ngrx/store'
import { createFormGroupState, formGroupReducer, onNgrxForms, onNgrxFormsAction, SetValueAction } from 'ngrx-forms'
import { AddressState } from './user-addresses.state'
import { AddressActions } from './user-addresses.actions'
import { Address } from '../user-profile/user-profile.state'

export const initialAddress: Address = {
  firstName: '',
  lastName: '',
  street: '',
  street2: '',
  company: '',
  postalCode: '',
  city: '',
  countryCode: '',
}

const initialState: AddressState = {
  addressToEdit: initialAddress,
  addresses: [],
  editPageControls: createFormGroupState<Address>('address-edit-page', initialAddress),
  newAddressControls: createFormGroupState<Address>('new-address-page', initialAddress),
}

export const addressReducer = createReducer(
  initialState,
  onNgrxForms(),
  onNgrxFormsAction(SetValueAction, (state, action) => ({
    ...state,
    editPageControls: formGroupReducer(state.editPageControls, action),
    newAddressControls: formGroupReducer(state.newAddressControls, action),
  })),
  on(AddressActions.setAddressToEdit, (state, action) => ({
    ...state,
    addressToEdit: action.payload,
    editPageControls: formGroupReducer(
      state.editPageControls,
      new SetValueAction<Address>(state.editPageControls.id, action.payload),
    ),
  })),
)
